import getDigitalData from './get-digital-data';
import readJSONFromScriptTag from '../../helpers/read-json-from-script-tag';

const {
  ENVIRONMENT,
  ADOBE_DTM_LIVE_ID,
  ADOBE_DTM_STAGE_ID,
} = readJSONFromScriptTag({ id: 'clientEnv' });

const getTrackingScriptSrc = () => {
  if (ENVIRONMENT === 'production') {
    return `//assets.adobedtm.com/launch-${ADOBE_DTM_LIVE_ID}.min.js`;
  }

  return `//assets.adobedtm.com/launch-${ADOBE_DTM_STAGE_ID}-development.min.js`;
};

window.digitalData = getDigitalData({
  ENVIRONMENT,
  window,
  serverTrackingData: readJSONFromScriptTag({ id: 'serverTrackingData' }),
});

// Append the tracking script to the page rather than include in the html
// because the code within tracking.js is run asynchronously because of the
// nature of how webpack works and therefore the digitalData object is
// not set by the time the tracking script loads - so we append it here instead.
if (ADOBE_DTM_LIVE_ID || ADOBE_DTM_STAGE_ID) {
  const trackingScript = document.createElement('script');
  trackingScript.src = getTrackingScriptSrc();
  trackingScript.async = true;
  document.head.appendChild(trackingScript);
}
